import { SipPlanMode } from '../../../api/types'
import { SipPlansListErrorState } from '../../sip-ui-components/SipPlansListErrorState'

type YourPlanPlansListErrorStateProps = {
  onRetry: () => void
}

export function YourPlanPlansListErrorState({ onRetry }: YourPlanPlansListErrorStateProps) {
  return <SipPlansListErrorState planMode={SipPlanMode.YOUR_PLAN} onRetry={onRetry} />
}
